import {getUserConfig} from "@utility/utils";

const initialState = {
    list: [],
    total: 0,
    loading: false,
    searching: false,
    mjRule: [],
    searchParams: {
        roomID: "",
        roomType: "",
        roundID: "",
        userID: "",
        settleID: "",
        start_date: new Date(),
        end_date: new Date(),
        page: 1,
        count: 10,
        refresh: false,
        ...getUserConfig("roomGameRecord")
    },
}

const roomGameRecord = (state = initialState, action) => {
    switch (action.type) {
        case 'ROOM_GAME_RECORD':
            return {
                ...state,
                ...action.payload
            }
        case 'ROOM_GAME_RECORD_INIT':
            return {
                ...initialState,
                mjRule: state.mjRule,
                searchParams: {
                    ...initialState.searchParams, ...getUserConfig("roomGameRecord")
                },
            }
        default:
            return {...state};
    }
}

export default roomGameRecord
